import { IdNamePair } from "./utils";

export type RelatedContractType = "claim" | "insuredgood";

export enum ContractCategoryType {
    ALL = "0",
}

export enum ContractType {
    VEHICLE = "Vehicle",
    HOUSES_PROPERTY = "HousingAndBelonging",
    FAMILY_AND_HEALTH = "FamilyAndHealth",
    TRAVEL_AND_LEISURE = "TravelAndLeisure",
    SAVINGS_AND_PENSION = "SavingsAndPension",
    LOANS_AND_INVESTMENTS = "LoansAndInvestments",
    LEGAL_PROTECTIONS = "LegalProtections",
    YOUR_ACTIVITIES = "YourActivities",
    YOUR_STAFF = "YourStaff",
    THE_MANAGER = "TheManager",
    ALL_TYPES = "AllContracts",
}

export type ContractSortProperty = Paths.ApiContract.Get.Parameters.SortProperty;

export interface Contract extends Omit<MyBrokerApi.ContractV2, "id"> {
    id: number;
    warrantiesList?: MyBrokerApi.Warranties[] | null;
    canAccessDetail?: boolean;
    productCode?: string;
}

export interface SearchableContract extends Omit<Contract, "dueDate" | "amount" | "reference"> {
    amountString?: string;
    dueDateString?: string;
    referenceString?: string;
}

export interface ContractDetail extends Omit<MyBrokerApi.ContractDetail, "effectiveDate" | "expirationDate"> {
    id: number;
    effectiveDate?: Date;
    expirationDate?: Date;
}

export type ContractCategory = MyBrokerApi.CategoryCounters;

export interface ContractPagination extends Omit<MyBrokerApi.ContractV2Payload, "result"> {
    result: Contract[];
}

export interface RelatedContract
    extends Omit<MyBrokerApi.RelatedContract, "id" | "contractBranch" | "contractRef" | "contractId"> {
    id: number;
    policyholderId: number;
    reference: string;
    state: IdNamePair;
    branch: IdNamePair;
    warrantiesList?: MyBrokerApi.Warranties[] | null;
    canAccessDetail?: boolean;
}

export interface RelatedContractPagination extends Omit<MyBrokerApi.RelatedContractPayload, "result"> {
    result: RelatedContract[];
}

export const defaultContractPagination = { result: [] as Contract[], total: 0 };

export const defaultRelatedContractPagination = { result: [] as RelatedContract[], total: 0 };
